import { useMutation } from '@tanstack/react-query';
import { ApiResponse, ShoppingItemData } from '../types/api';
import WebApp from '@twa-dev/sdk';


const API_URL = 'https://red.sigma-dev.co.ua/mini/shop/clear';

async function fetchData(): Promise<void> {
  const response = await fetch(API_URL, {
    method: 'DELETE',
    headers: {
      'init-data': WebApp.initData,
    },
  });
  if (response.status > 299) {
    throw new Error('Network response was not ok');
  }
  return ;
}

export function useApiShopClearCompleted() {
  return useMutation<void, Error, undefined>({
    mutationFn: fetchData,
    mutationKey: ['shopClearCompleted'],
  });
} 